import React from "react";
import { Redirect } from "react-router-dom";

export default class RedirectComponent extends React.Component {
  state = {
    shouldRedirectToPage: false
  };

  componentDidMount() {
    const protocol = window.location.protocol;
    if (this.validateFileExtension(this.props.match.params.uid)) {
      window.location = `${protocol}//files.institutesi.org/${
        this.props.match.params.uid
      }`;
    } else {
      this.setState({
        shouldRedirectToPage: true
      });
    }
  }

  validateFileExtension(file) {
    if (!/(\.txt|\.pdf|\.exls|\.doc|\.docx|\.xls)$/i.test(file)) {
      return false;
    }
    return true;
  }

  renderRedirect() {
    return <Redirect to={`/pages/${this.props.match.params.uid}`} />;
  }

  render() {
    return (
      <section>
        {this.state.shouldRedirectToPage
          ? this.renderRedirect()
          : "Redirecting..."}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Redirect.js